<template>
  <a-tooltip :title="text" :disabled="!isOverflow">
    <div 
      ref="textRef" 
      class="auto-ellipsis" 
      @mouseenter="handleMouseEnter"
    >
      {{ text }}
      
    </div>
  </a-tooltip>
</template>

<script lang="ts" setup>
import { ref, defineProps } from 'vue';

const props = defineProps({ text: String });
const textRef = ref(null);
const isOverflow = ref(false);

const handleMouseEnter = () => {
  const el = textRef.value;
  if (el) {
    // 只有文字溢出了，Tooltip 才生效
    isOverflow.value = el.scrollWidth > el.offsetWidth;
  }
};
</script>

<style scoped>
.auto-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;
}
</style>